<ion-app>
  <ion-router-outlet
    [animated]="iosSwipeNavigationEnabled"
    [swipeGesture]="iosSwipeNavigationEnabled"
  ></ion-router-outlet>
</ion-app>
